module.exports = __webpack_public_path__ + "static/GAPISetup-ca3046a7619b99341a575d54ade258fe.png";